import styled from 'styled-components';

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 25px;
`;